const initialState = {
  address: "",
  balance: 0,
};

export const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setLoading":
      return {
        ...state,
        loading: action.payload,
      };
    case "Connect_Wallet":
      return {
        ...state,
        address: action.payload.address,
      };
    case "GetBalance":
      return {
        ...state,
        balance: action.payload,
      };
    case "SetStakingValue":
      return {
        ...state,
        valStaking: action.payload,
      };
    case "SetUnStakingValue":
      return {
        ...state,
        valUnStaking: action.payload,
      };
    case "setFormStackingError":
      return {
        ...state,
        isFormStackingErr: action.payload,
      };
    case "setFormUnStackingError":
      return {
        ...state,
        isFormUnStackingErr: action.payload,
      };
    case "setActionCurrIsStaking":
      return {
        ...state,
        isStakingActionCurr: action.payload,
      };
    case "setDoneApproveStaking":
      return {
        ...state,
        isDoneApproveStaking: action.payload,
      };
    case "setDoneApproveUnStaking":
      return {
        ...state,
        isDoneApproveUnStaking: action.payload,
      };
    case "setSocketPrice":
      return {
        ...state,
        priceSocket: action.payload,
      };
    case "setTokenStacked":
      return {
        ...state,
        tokenStaked: action.payload,
      };
    case "setInfoStakingToken":
      return {
        ...state,
        tokenStakingInfo: action.payload,
      };
    case "setDoneStakingAction":
      return {
        ...state,
        isDoneActionStaking: action.payload,
      };
    default:
      return state;
  }
};
